/**
 * Модуль для обработки ошибок
 */

/**
 * Создает глобальные обработчики ошибок
 */
export function setupGlobalErrorHandlers({
  getTelegramWebApp,
  showErrorAlert = true,
  logErrors = true
}) {
  /**
   * Обработчик JavaScript ошибок
   */
  function handleJavaScriptError(event) {
    try {
      // Игнорируем внутренние ошибки Telegram WebApp SDK (peer changed и подобные)
      const filename = event.filename || event.source || '';
      const message = event.message || '';
      const stack = event.error?.stack || '';
      
      if (message && (
        message.includes('peer changed') ||
        message.includes('bubbles.ts') ||
        message.includes('appImManager.ts') ||
        filename.includes('telegram-web-app.js') ||
        filename.includes('peerProfile.tsx') ||
        filename.includes('solid.js') ||
        stack.includes('peerProfile.tsx') ||
        stack.includes('solid.js:') ||
        (message.includes('Cannot access') && (stack.includes('peerProfile') || stack.includes('solid.js')))
      )) {
        // Это внутренние ошибки Telegram WebApp SDK, не критичны
        return false;
      }
      
      if (logErrors) {
        console.error("❌ ОШИБКА JavaScript:", event.error);
        console.error("   Сообщение:", event.message);
        console.error("   Файл:", event.filename);
        console.error("   Строка:", event.lineno);
        console.error("   Колонка:", event.colno);
        console.error("   Стек:", event.error ? event.error.stack : "нет стека");
      }
      
      if (showErrorAlert) {
        const telegramWebApp = getTelegramWebApp();
        if (telegramWebApp && telegramWebApp.showAlert) {
          telegramWebApp.showAlert(`❌ Ошибка JS:
${event.message}
Строка: ${event.lineno}`);
        }
      }
    } catch (error) {
      // Fallback на window.alert если что-то пошло не так
      if (window.alert) {
        window.alert("Критическая ошибка: " + error.message);
      }
    }
  }

  /**
   * Обработчик необработанных промисов
   */
  function handleUnhandledRejection(event) {
    // Игнорируем внутренние ошибки Telegram WebApp SDK (peer changed и подобные)
    const reason = event.reason?.message || event.reason?.toString() || '';
    if (reason.includes('peer changed') || 
        reason.includes('bubbles.ts') || 
        reason.includes('appImManager.ts')) {
      // Это внутренние ошибки Telegram WebApp SDK, не критичны
      event.preventDefault();
      return;
    }
    
    if (logErrors) {
      console.error("[GLOBAL ERROR] Unhandled promise rejection:", {
        reason: event.reason,
        promise: event.promise,
        error: event.reason?.message || event.reason,
        stack: event.reason?.stack,
        ts: new Date().toISOString()
      });
    }
    
    // Не блокируем выполнение
    event.preventDefault();
  }

  /**
   * Устанавливает глобальные обработчики ошибок
   */
  function setup() {
    window.addEventListener("error", handleJavaScriptError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);
  }

  /**
   * Удаляет глобальные обработчики ошибок
   */
  function cleanup() {
    window.removeEventListener("error", handleJavaScriptError);
    window.removeEventListener("unhandledrejection", handleUnhandledRejection);
  }

  return {
    setup,
    cleanup,
    handleJavaScriptError,
    handleUnhandledRejection
  };
}

/**
 * Создает безопасную обертку для fetch с обработкой ошибок
 */
export function createSafeFetchWrapper({
  baseSafeFetch,
  handleInvalidInitData,
  processAchievementPayload
}) {
  /**
   * Безопасный fetch с дополнительной обработкой ошибок
   */
  async function safeFetchWithEnhancements(resource, options = {}) {
    const response = await baseSafeFetch(resource, options);
    
    if (response.success) {
      // Обрабатываем достижения, если есть
      if (processAchievementPayload && response.data) {
        processAchievementPayload(response.data);
      }
      return response;
    }
    
    // Обрабатываем ошибки авторизации
    if (handleInvalidInitData &&
        (response.error === "invalid_init_data" || response.status === 401)) {
      handleInvalidInitData(response.error || response.status);
    }
    
    return response;
  }

  return {
    safeFetchWithEnhancements
  };
}





